module.exports = "/images/marking-icon-checkbox-checked.svg?16439b55cbaa045b0afaeddd82cdebae";